<!-- 解决方案/智能制造能力 -->
<template>
  <div class="solution">
    <!-- 背景图 -->
    <TopImg :title="topImg.title" :content="topImg.content" :image="topImg.bgImg" :bl="topImg.bl"></TopImg>
    <!-- 方案简介 -->
    <Introduction :title="propsCon.title" :content="propsCon.content" :image="propsCon.img"></Introduction>
    <!-- 模型等级 -->
    <div class="modelCon">
      <ModelImg
        :title="modelCon.title"
        :content="modelCon.content"
        :image="modelCon.img"
        :bgimage="modelCon.bgImg"
      ></ModelImg>
      <ListItem :modelList="modelList" class="listModel"></ListItem>
    </div>
    <!-- 底部流程 -->
    <Follow></Follow>
    <!-- 底部 -->
    <div class="el-footer">
      <Footer />
    </div>
  </div>
</template>

<script>
import TopImg from '../components/TopImg'
import Introduction from '../components/Introduction'
import ModelImg from '../components/ModelImg'
import ListItem from '../components/ListItem'
import Follow from '../components/Follow'
import Footer from '../components/Footer.vue'
export default {
  name: '',
  components: { TopImg, Introduction, ModelImg, ListItem, Follow, Footer },
  props: {},
  data() {
    return {
      topImg: {
        title: '企业上云能力咨询评估',
        bgImg: require('../assets/images/u1018.png'),
        content:
          '提供江苏省星级上云企业评定的咨询评估服务，同时提供全面的企业上云应用产品，满足企业三星、四星、五星的建设需求。',
        bl: true,
      },
      propsCon: {
        title: '方案简介',
        content: [
          '“企业上云”是指企业通过高速互联网络，将企业的基础系统、业务、平台部署到云端，利用网络便捷地获取计算、存储、数据、应用等服务，有利于降低企业信息化建设成本，构建工业互联网创新发展生态，促进实现制造业全过程、全产业链和产品全生命周期的优化，提升制造业与互联网融合发展水平。',
          '本项目是深入了解企业现状，客观评估并作出指导，根据企业上云建设的需求，按照江苏省星级上云企业评定工作指南给出定制化的解决方案，为企业提供上云咨询-上云系统部署服务。',
        ],
        img: require('../assets/images/u1025.png'),
      },
      modelCon: {
        title: '上云内容',
        content: [
          '工业互联网作为信息技术与工业制造深度融合的产物，日益成为产业全要素、全产业链、全价值链连接的关键支撑，并作为企业数字化、网络化、智能化的基础设施在转型升级过程中发挥重要作用，中国企业必将加深对云计算的依赖程度，通过上云提升信息化应用水平，促进产业升级换代。根据企业对云服务的不同需求，企业上云的内容可分为基础设施上云、企业平台系统上云、企业业务系统上云等三部分。',
        ],
        img: require('../assets/images/u1035.png'),
        bgImg: require('../assets/images/u861.png'),
      },
      modelList: [
        {
          title: '规划级',
          content: [
            ' 企业有了实施智能制造的想法，开始进行规划和投资。部分核心的制造环节已实现业务流程信息化，具备部分满足未来通信和集成需求的基础设施，企业已开始基于IT进行制造活动，单只是具备实施智能制造的基础条件，还未真正进入到智能制造的范畴',
          ],
          img: require('../assets/images/u1034.png'),
          modelModel: 'lr',
        },
        {
          title: '规范级',
          content: [
            ' 企业已经形成了智能制造的规划，对支撑核心业务的设备和系统进项了投资，通过技术改造，使得主要设备数据采集和通信的能力，实现了覆盖核心业务重要环节的自动化、数字化升级。通过制定标准化的接口和数据格式，部分支撑生产作业的信息系统能够实现内部集成，数据和信息在业务内部实现共享，企业开始迈进智能制造的门槛',
          ],
          img: require('../assets/images/u1042.png'),
          modelModel: 'lr',
        },
        {
          title: '引领级',
          content: [
            ' 智能制造能力建设的最高程度，在这个级别下，数据的分析使用已贯穿企业的方方面面，各类生产资源都得以最优化的利用，设备之间实现自治的反馈和优化，企业已成为上下游产业链中的重要角色，个性化定制、网络协同、远程运维已成为企业开展业务的主要模式，企业成为本行业智能制造的标杆',
          ],
          img: require('../assets/images/u1043.png'),
          modelModel: 'lr',
        },
      ],
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
}
</script>

<style scoped lang="less">
.modelCon {
  position: relative;
}
.listModel {
  position: absolute;
  left: 50%;
  -webkit-transform: translate(-50%, 50%);
  -moz-transform: translate(-50%, 50%);
  transform: translate(-50%, 50%);
  bottom: 0;
  width: 100%;
}
</style>
